import { LoadablePaint } from '@confluence/loadable';

export const ViewXlsMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewXlsMacro" */ '../src/ViewXlsMacroRenderer.tsx'
			)
		).ViewXlsMacroRenderer,
});
